import AcademicPage from "./AcademicPage"; 
import EnrichPage from "./EnrichPage";
import EdutainmentPage from "./EdutainmentPage";
import PrintRichPage from "./PrintRichPage";
import MakerPage from "./MakerPage";
import InfoHubPage from "./InfoHubPage";

export default function AllPage({ page, selectedStage, onSelectStage }) {
  switch (page) {
    case "early-career":
      return <EnrichPage />;
    
    case "edutainment":
      return <EdutainmentPage />;
    
 case "print-rich":
      return <PrintRichPage />;

    case "maker":
      return <MakerPage />;
          case "info-hub":
      return <InfoHubPage />;

    case "academic":
    default:
      return <AcademicPage selectedStage={selectedStage} onSelectStage={onSelectStage} />;
  }
}
